import React,{useEffect} from 'react';
export default ({children})=>{

return (
    <div className="content animated faster q0" data-animatequeue="fadeInUp">
        {children}
    </div>
)
  
}